import type { RouteRecordRaw } from 'vue-router';
export const logisticsRoutes: RouteRecordRaw[] = [
  {
    path: 'logistics',
    name: 'logistics',
    component: () => import('../pages/logistics/LogisticsPage.vue'),
    meta: { requiresModule: 'logistics' },
  },
];
